export const generateData = (length, options) => {
    let a = [];
    for(let i =0 ; i <length; i++){
        a.push(Math.random() * 100 )
    }
    //console.log(a)
    return a;
}
export const isMobile = () => window.innerWidth < 640;
export const isTablet = () => window.innerWidth < 1024;
export const isDesktop = () => window.innerWidth >= 1024;

export const csrf = () => document.querySelector('meta[name="csrf-token"]').content;
export const isDarkMode = () => document.documentElement.classList.contains('dark');